import { useState } from 'react';

import { Button } from 'antd';

import Globe from '@/components/icons/Globe';
import Percent from '@/components/icons/Percent';
import FixedFee from '@/components/modals/FixedFee';
import InternationalFee from '@/components/modals/InternationalFee';
import useProductStore from '@/stores/productStore';

export const PaymentTaxes = () => {
  const [openTaxes, setOpenTaxes] = useState(false);
  const [openInternationalTaxes, setOpenInternationalTaxes] = useState(false);

  const productPaymentType = useProductStore(d => d.payment.type);

  if (productPaymentType === 'free') {
    return null;
  }

  return (
    <>
      <div className='flex flex-col items-start gap-1'>
        <Button
          id='taxes-link'
          type='text'
          color='primary'
          size='small'
          className='h-auto px-0 underline'
          icon={<Percent className='h-3.5 w-3.5' />}
          onClick={() => setOpenTaxes(true)}
        >
          Entenda as taxas
        </Button>

        <Button
          id='taxes-link-international'
          type='text'
          color='primary'
          size='small'
          className='h-auto px-0 underline'
          icon={<Globe className='h-3.5 w-3.5' />}
          onClick={() => setOpenInternationalTaxes(true)}
        >
          Internacional
        </Button>
      </div>

      <FixedFee openTaxes={openTaxes} setOpenTaxes={setOpenTaxes} />
      <InternationalFee
        openInternationalTaxes={openInternationalTaxes}
        setOpenInternationalTaxes={setOpenInternationalTaxes}
      />
    </>
  );
};
